import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { Slider } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import MediaQuery from "react-responsive";
import Cookies from "js-cookie";

import server from "../../../../functions/server";

const convertData = (data) => {
  const dateStr = data;

  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  const formattedDate = `${day.toString().padStart(2, "0")}/${month
    .toString()
    .padStart(2, "0")}/${year.toString()}`;

  return formattedDate;
};

export const getStatus = async (
  numnota,
  cte,
  setOpen,
  setInfo,
  productsArr,
  qtdsArr,
  seriesArr,
) => {
  const params = new URLSearchParams({ cte, numnota });

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + Cookies.get("bearer"),
    },
    body: params,
  };

  const productsArray = productsArr.split(";");
  const qtdsArray = qtdsArr.split(";");
  const seriesArray = seriesArr.split(";");

  let newProducts = [];

  productsArray.map((unique, index) => {
    newProducts.push({
      id: index + 1,
      product: unique,
      qtd: qtdsArray[index],
      serie: seriesArray[index],
    });

    return newProducts;
  });

  newProducts = newProducts
    .filter((unique, index) => newProducts.indexOf(unique) === index)
    .filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.product === item.product),
    );

  const infoLife = await fetch(`${server}portalCliente/consulta/life`, options)
    .then((response) => response.json())
    .then((response) => {
      return response?.data?.data;
    });

  if (infoLife?.length > 0) {
    const marks = [
      {
        id: 0,
        value: 0,
        label: "RECEPCIONADO",
      },
      {
        id: 7,
        value: 20,
        label: "CT-E EMITIDO",
      },
      {
        id: 15,
        value: 40,
        label: "Inicio de Transferência",
      },
      {
        id: 16,
        value: 60,
        label: "Transferência Finalizada",
      },
      {
        id: 4,
        value: 80,
        label: "Em rota de entrega",
      },
      {
        id: 1,
        value: 100,
        label: "Entrega Realizada",
      },
    ];

    const getValue = marks.filter(
      (unique) =>
        unique.id === infoLife?.[infoLife.length - 1]?.occurrence.code,
    )?.[0]?.value;

    const concat = (
      <>
        <h2>
          <b>Entrega #{numnota}</b>
        </h2>

        <p>
          Vendido por <b>MedSystems</b> e entregue por LifeCargo
        </p>
        <b>
          Previsão de Entrega:{" "}
          {convertData(infoLife[0].freight.delivery_prediction_at)}
        </b>
        <center>
          <MediaQuery orientation="landscape">
            <Slider
              value={getValue}
              ThumbComponent={LocalShippingIcon}
              marks={marks}
              aria-label="slider"
              sx={{ mt: 2, ml: 3, width: "70vw" }}
              disabled
            />
          </MediaQuery>
        </center>

        {infoLife.map((element) => {
          return (
            <p>
              <b>Data: </b> {convertData(element.created_at)} -{" "}
              {element.occurrence.description}
            </p>
          );
        })}

        <h2>
          <b>Produtos do Pedido</b>
        </h2>
        <MediaQuery orientation="portrait">
          {newProducts.map((item) => (
            <p key={item.id}>
              <b>Produto: </b> {item.product} | <b>Qtd: </b> {item.qtd} |{" "}
              <b>Série/Lote: </b> {item.serie}
            </p>
          ))}
        </MediaQuery>
        <MediaQuery orientation="landscape">
          <DataGrid
            rows={newProducts}
            columns={[
              { field: "id", headerName: "ID", width: 5 },
              { field: "product", headerName: "Produtos", width: 500 },
              { field: "qtd", headerName: "Quantidade", width: 100 },
              { field: "serie", headerName: "Série/Lote", width: 250 },
            ]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5]}
            disableRowSelectionOnClick
          />
        </MediaQuery>
      </>
    );

    setOpen(true);
    setInfo(concat);

    return;
  }

  const optionsLocale = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + Cookies.get("bearer"),
    },
    body: new URLSearchParams({
      jsonid: localStorage.getItem("token"),
      numnota,
    }),
  };

  const infoLocale = await fetch(
    `${server}portalCliente/consulta/entrega_local`,
    optionsLocale,
  )
    .then((response) => response.json())
    .then((response) => {
      return response.data[0];
    });

  if (infoLocale) {
    const marks = [
      {
        id: 0,
        value: 0,
        label: "Aguardando Carregamento",
      },
      {
        id: 1,
        value: 33,
        label: "Carregado",
      },
      {
        id: 2,
        value: 66,
        label: "Em Trânsito",
      },
      {
        id: 3,
        value: 100,
        label: "Entregue",
      },
    ];

    const getValue = marks.filter((unique) => unique.id === infoLocale[1])[0]
      .value;

    const concat = (
      <>
        <h2>
          <b>Entrega</b>
        </h2>
        <p>
          Vendido e entregue por <b>MedSystems</b>
        </p>
        <b>Previsão de Entrega: {infoLocale[0]}</b>
        <center>
          <MediaQuery orientation="landscape">
            <Slider
              value={getValue}
              ThumbComponent={LocalShippingIcon}
              marks={marks}
              aria-label="slider"
              sx={{ mt: 2, ml: 3, width: "70vw" }}
              disabled
            />
          </MediaQuery>
        </center>
        <p>Entrega: </p>
        <p>
          <b>Data de Atualização: </b> {infoLocale[2]}
        </p>

        <h2>
          <b>Produtos do Pedido</b>
        </h2>
        <DataGrid
          rows={newProducts}
          columns={[
            { field: "id", headerName: "ID", width: 5 },
            { field: "product", headerName: "Produtos", width: 500 },
            { field: "qtd", headerName: "Quantidade", width: 100 },
            { field: "serie", headerName: "Série/Lote", width: 250 },
          ]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
        />
      </>
    );

    setOpen(true);
    setInfo(concat);
    return;
  }

  //Caso não haja informações de entrega, exibe mensagem padrão
  const concat = (
    <>
      <h2>
        <b>Entrega</b>
      </h2>
      <p>
        Vendido e entregue por <b>MedSystems</b>
      </p>
      <p>Não há informações de entrega disponíveis para este pedido.</p>
    </>
  );

  setOpen(true);
  setInfo(concat);
  return;
};
